import { Lock } from 'lucide-react';

import { INSTITUTE_DEMO_ACCOUNTS, PLATFORM_DEMO_ACCOUNTS } from '../constants/demoAccounts';
import { SignInForm } from '../components/SignInForm';

/**
 * The one sign-in screen, at `/login`, for everybody.
 *
 * There is one login endpoint and the role decides where each person lands, so
 * school staff, teachers, students, parents and our own platform team all sign
 * in here.
 */
export function LoginPage() {
  return (
    <div className="flex flex-col gap-5 sm:gap-6">
      <div className="flex flex-col gap-1.5 text-left">
        <div className="inline-flex items-center gap-2 text-xs font-bold text-accent uppercase tracking-wider">
          <Lock className="h-3.5 w-3.5" /> Portal Sign In
        </div>
        <h1 className="text-xl sm:text-2xl font-extrabold text-ink tracking-tight leading-snug">
          Sign in to your account
        </h1>
        <p className="text-xs sm:text-sm text-ink-2 font-medium">
          Use the registered email address or mobile number provided by your school office.
        </p>
      </div>

      <SignInForm demoAccounts={[...INSTITUTE_DEMO_ACCOUNTS, ...PLATFORM_DEMO_ACCOUNTS]} />

      <p className="text-center text-2xs sm:text-xs text-ink-3 font-medium">
        Account credentials are provided by your school office. Contact support if you need assistance.
      </p>
    </div>
  );
}
